var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27039 2.06004L5.52039 1.03004C5.23539 0.925044 4.77039 0.925044 4.48539 1.03004L1.73539 2.06004C1.20539 2.26004 0.775391 2.88004 0.775391 3.44504V7.49504C0.775391 7.90004 1.04039 8.43504 1.36539 8.67504L4.11539 10.73C4.60039 11.095 5.39539 11.095 5.88039 10.73L8.63039 8.67504C8.95539 8.43004 9.22039 7.90004 9.22039 7.49504V3.44504C9.22539 2.88004 8.79539 2.26004 8.27039 2.06004ZM6.34039 6.98504C6.26539 7.06004 6.17039 7.09504 6.07539 7.09504C5.98039 7.09504 5.88539 7.06004 5.81039 6.98504L5.01539 6.19004L4.19539 7.01004C4.12039 7.08504 4.02539 7.12004 3.93039 7.12004C3.83539 7.12004 3.74039 7.08504 3.66539 7.01004C3.52039 6.86504 3.52039 6.62504 3.66539 6.48004L4.48539 5.66004L3.68539 4.86004C3.54039 4.71504 3.54039 4.47504 3.68539 4.33004C3.83039 4.18504 4.07039 4.18504 4.21539 4.33004L5.01039 5.12504L5.78539 4.35004C5.93039 4.20504 6.17039 4.20504 6.31539 4.35004C6.46039 4.49504 6.46039 4.73504 6.31539 4.88004L5.54039 5.65504L6.33539 6.45004C6.48539 6.60004 6.48539 6.83504 6.34039 6.98504Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDanger);
export default __webpack_public_path__ + "static/media/shield-danger.ff8e3491f0de656e957f3efb6167642b.svg";
export { ForwardRef as ReactComponent };